module.exports = __webpack_public_path__ + "static/sample-21-f084e59163c792bf9aaa055e1cbee748.png";